import { brazilianStates } from '@common';
import { InputMask } from '@components/atoms';
import { Checkbox, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { useEffect } from 'react';

interface FormAddressProps {
	showCopy?: boolean;
	onChangeCep?: (cep: any) => void;
	defaultMemberAddress: boolean;
}

const apiCep = axios.create({
	baseURL: 'https://viacep.com.br/ws/',
});

export const FormAddress = ({ showCopy, onChangeCep, defaultMemberAddress }: FormAddressProps) => {
	const isSpouseAddress = Form.useWatch('isSpouseAddress');

	useEffect(() => {
		if (isSpouseAddress && !defaultMemberAddress) {
			message.error('Para prosseguir é necessário que o endereço seja previamente cadastrado na aba anterior.');
		}
	}, [isSpouseAddress, defaultMemberAddress]);

	const handleChangeCep = (cep: string) => {
		const value = cep.replace(/\D/g, '');

		if (value.length === 8) {
			apiCep
				.get<any>(`${value}/json`)
				.then((res) => onChangeCep?.(res.data));
		}
	};

	return (
		<div className='space-y-6'>
			{showCopy && (
				<Form.Item name='isSpouseAddress' valuePropName='checked'>
					<Checkbox>Preencher com dados do cônjuge</Checkbox>
				</Form.Item>
			)}

			{!isSpouseAddress && (
				<>
					<Form.Item label='CEP' name='cep' >
						<InputMask
							mask='cep'
							onChange={(e) => handleChangeCep(e.target.value)}
						/>
					</Form.Item>

					<Form.Item label='Logradouro' name='street'>
						<Input />
					</Form.Item>

					<div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
						<Form.Item label='Número' name='number'>
							<Input placeholder='Digite o número' />
						</Form.Item>

						<Form.Item label='Complemento' name='complement'>
							<Input placeholder='Digite o complemento' />
						</Form.Item>

						<Form.Item label='Bairro' name='neighborhood'>
							<Input placeholder='Digite o bairro' />
						</Form.Item>
					</div>

					<div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
						<Form.Item label='Cidade' name='city'>
							<Input />
						</Form.Item>

						<Form.Item label='Estado' name='state' rules={[{ required: true }]}>
							<Select
								showSearch
								optionFilterProp='label'
								options={brazilianStates}
							/>
						</Form.Item>
					</div>
				</>
			)}
		</div>
	);
};
